<!-- =========================================================================================
    File Name: i18n.vue
    Description: I18n demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-3/4 sm:w-2/3 w-full">
          <import-excel :onSuccess="loadDataInTable" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
          <card-download-template type="customer"></card-download-template>
        </div>
      </div>
    </div>

    <vx-card v-if="state === 'list' ">
      <vs-table stripe pagination :max-items="maxItems" search :data="tableData">
        <template slot="header">
          <div class="w-1/3 mr-3"><v-select v-model="importType" :clearable="false" :options="importCustomerTypesOptions" :reduce="res => res.value" name="status"/></div>
          <div class="w-1/3">
            <vs-button color="warning" type="filled" @click="submit('check')" v-if="pms ('CustomerImport', 'create', 'b') ">ตรวจสอบข้อมูล</vs-button>
          </div>
        </template>

        <template slot="thead">
          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
              {{ col }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card v-if="state === 'checked'">
      <vs-table :data="result">
        <template slot="header">
          <div>
            <vs-button color="success" type="filled" @click="submit('import')" v-if="pms ('CustomerImport', 'create', 'b') && state === 'checked'" :disabled="result.filter(res => res.error == true).length >= 1">นำเข้าข้อมูล</vs-button>
          </div>
        </template>
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>ผลการตรวจสอบ</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="tr.success == true ? 'success' : 'danger'" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12">
              {{ (indextr+1) }}
            </vs-td>
            <vs-td class="w-7/12">
              {{ tr.errorMassage }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card v-if="state === 'imported'">
      <vs-table :data="result">
        <template slot="header">
          <div>
            {{ $t("general.importResultTitle", {total: result.length, success: result.filter(res => res.success == true).length, error: result.filter(res => res.error == true).length}) }}
          </div>
        </template>
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>ผลการนำเข้า</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="tr.success == true ? 'success' : 'danger'" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12">
              {{ (indextr+1) }}
            </vs-td>
            <vs-td class="w-7/12">
              {{ tr.errorMassage }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div>
        <div class="w-1/3">
          <vs-button color="success" type="filled" @click="submit('import')" v-if="pms ('CustomerImport', 'create', 'b') && state === 'checked'" :disabled="result.filter(res => res.error == true).length >= 1">นำเข้าข้อมูล</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ImportExcel from './Excel/ImportExcel.vue'
import vSelect from 'vue-select'
import { mapGetters, createNamespacedHelpers } from 'vuex'
const moment = require('moment');
const { mapActions: mapCustomerActions, mapState: mapCustomerStates } = createNamespacedHelpers('Customer')

export default {
  components: {
    ImportExcel,
    vSelect,
    CardDownloadTemplate: () => import('@/components/shared/card/CardDownloadTemplate.vue'),
  },
  data () {
    return {
      form: [],
      importType: { label: 'Borrowers',  value: 'Borrowers' },
      maxItems: 100,
      state: 'null',
      meta: {},
      tableData: [],
      header: [],
      result: []
    }
  },
  filters: {
    resultStatus: function(res) {
      if(res.success){
        return "Success"
      }else{
        return "Error"
      }
    }
  },
  async created() {
    this.pms ('CustomerImport', 'visible', 'r')
  },
  computed: {
    ...mapCustomerStates(['status']),
    ...mapGetters({
      importCustomerTypesOptions :'Master/importCustomerTypesOptions',
    }),

  },
  methods: {
    ...mapCustomerActions(['importBorrowers', 'importSureties', 'importBorrowersUpdate', 'importSuretiesUpdate']),
    convExcelDate (dd) {
      const utc_days  = Math.floor(dd - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      return moment(date_info).format("YYYY-MM-DD")
    },
    loadDataInTable ({ results, header, meta }) {
      const vm = this
      vm.header = header
      vm.tableData = results
      vm.meta = { fileName: meta.fileName}
      vm.state = 'list'
      vm.importType = {
        label: meta.importType,
        value: meta.importType
      }
      if( meta.importType === "BorrowersUpdate"){
        vm.tableData = results.map(result =>{
          let BirthDay = vm.convExcelDate(result.BirthDay)
          let IssueDate = vm.convExcelDate(result.IssueDate)
          let ExpDate = vm.convExcelDate(result.ExpDate)
          return {
            ...result,
            BirthDay,
            IssueDate,
            ExpDate
          }
        })
      }
      if( meta.importType === "SuretiesUpdate"){
        vm.tableData = results.map(result =>{
          let BirthDay = vm.convExcelDate(result.BirthDay)
          let IssueDate = vm.convExcelDate(result.IssueDate)
          let ExpDate = vm.convExcelDate(result.ExpDate)
          return {
            ...result,
            BirthDay,
            IssueDate,
            ExpDate
          }
        })
      }
      if( meta.importType === "Sureties"){
        vm.tableData = results.map(result =>{
          let BirthDay = vm.$options.filters.convDDMMYYYYToYYYYMMDD(result.BirthDay)
          let IssueDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(result.IssueDate)
          let ExpDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(result.ExpDate)
          return {
            ...result,
            BirthDay,
            IssueDate,
            ExpDate
          }
        })
      }
    },
    async submit (action) {
      const vm = this
      const importType = vm.importType.value || vm.importType
      const convStr = (str) => {
        try {
          return str.toString().trim()
        } catch (error) {
          return str
        }
      }

      try {
        if(importType == "Borrowers"){
          let form = this.tableData.map(res => {
            return {
              prefix: { nameTh: convStr(res["Prefix"]) },
              name: convStr(res["Name"]),
              surname: convStr(res["Surname"]),
              birthDay: convStr(res["BirthDay"]),
              idCardNumber: convStr(res["IdCardNumber"]),
              issueDate: convStr(res["IssueDate"]),
              expDate: convStr(res["ExpDate"]),
              career: convStr(res["Occupation"]),
              position: convStr(res["Position"]),
              affiliate: convStr(res["Affiliate"]),
              studentCode: convStr(res["StudentCode"]),
              project: { projectNo: convStr(res["ProjectNo"]) },
              degree: { nameTh: convStr(res["Degree"]) },
              period: { name: convStr(res["Period"]) },
              periodTerm: convStr(res["Period"]).split('/')[0].toString(),
              periodYear: parseInt(convStr(res["Period"]).split('/')[1]),
              curriculum: { curriculumNo: convStr(res["CurriculumNo"]) },
              address: {
                location: convStr(res["Location"]),
                houseNumber: convStr(res["HouseNumber"]),
                moo: convStr(res["Moo"]),
                alley: convStr(res["Alley"]),
                road: convStr(res["Road"]),
                subDistrict: convStr(res["SubDistrict"]),
                district: convStr(res["District"]),
                province: convStr(res["Province"]),
                zipcode: convStr(res["Zipcode"]),
                locationDoc: convStr(res["LocationDoc"]),
                houseNumberDoc: convStr(res["HouseNumberDoc"]),
                mooDoc: convStr(res["MooDoc"]),
                alleyDoc: convStr(res["AlleyDoc"]),
                roadDoc: convStr(res["RoadDoc"]),
                subDistrictDoc: convStr(res["SubDistrictDoc"]),
                districtDoc: convStr(res["DistrictDoc"]),
                provinceDoc: convStr(res["ProvinceDoc"]),
                zipcodeDoc: convStr(res["ZipcodeDoc"]),
              },
              phone: convStr(res["Phone"]),
              mobile: convStr(res["Mobile"]),
              email: convStr(res["Email"])
            }
          });
          vm.$vs.loading()
          const result = await vm.importBorrowers({
            action: action,
            meta: {...vm.meta, action: action},
            form,
            vm,
            redirect: null
          })
          if(action === "check"){
            vm.check = true
            vm.result = result
            vm.state = 'checked'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }else{
            vm.check = false
            vm.header = []
            vm.tableData = []
            vm.result = result
            vm.state = 'imported'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }
        }
        else if(importType == "Sureties"){
          let form = this.tableData.map(res => {
            return {
              prefix: { nameTh: convStr(res["Prefix"]) },
              name: convStr(res["Name"]),
              surname: convStr(res["Surname"]),
              birthDay: convStr(res["BirthDay"]),
              idCardNumber: convStr(res["IdCardNumber"]),
              issueDate: convStr(res["IssueDate"]),
              expDate: convStr(res["ExpDate"]),
              career: convStr(res["Occupation"]),
              position: convStr(res["Position"]),
              affiliate: convStr(res["Affiliate"]),
              address: {
                location: convStr(res["Location"]),
                houseNumber: convStr(res["HouseNumber"]),
                moo: convStr(res["Moo"]),
                alley: convStr(res["Alley"]),
                road: convStr(res["Road"]),
                subDistrict: convStr(res["SubDistrict"]),
                district: convStr(res["District"]),
                province: convStr(res["Province"]),
                zipcode: convStr(res["Zipcode"]),
                locationDoc: convStr(res["LocationDoc"]),
                houseNumberDoc: convStr(res["HouseNumberDoc"]),
                mooDoc: convStr(res["MooDoc"]),
                alleyDoc: convStr(res["AlleyDoc"]),
                roadDoc: convStr(res["RoadDoc"]),
                subDistrictDoc: convStr(res["SubDistrictDoc"]),
                districtDoc: convStr(res["DistrictDoc"]),
                provinceDoc: convStr(res["ProvinceDoc"]),
                zipcodeDoc: convStr(res["ZipcodeDoc"]),
              },
              phone: convStr(res["Phone"]),
              mobile: convStr(res["Mobile"]),
              email: convStr(res["Email"])
            }
          });
          vm.$vs.loading()
          const result = await vm.importSureties({
            action: action,
            meta: {...vm.meta, action: action},
            form,
            vm,
            redirect: null
          })
          if(action === "check"){
            vm.check = true
            vm.result = result
            vm.state = 'checked'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }else{
            vm.check = false
            vm.header = []
            vm.tableData = []
            vm.result = result
            vm.state = 'imported'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }
        }
        else if(importType == "BorrowersUpdate"){
          let form = this.tableData.map(res => {
            return {
              prefix: { nameTh: convStr(res["Prefix"]) },
              name: convStr(res["Name"]),
              surname: convStr(res["Surname"]),
              birthDay: convStr(res["BirthDay"]),
              idCardNumber: convStr(res["IdCardNumber"]),
              issueDate: convStr(res["IssueDate"]),
              expDate: convStr(res["ExpDate"]),
              career: convStr(res["Occupation"]),
              position: convStr(res["Position"]),
              affiliate: convStr(res["Affiliate"]),
              studentCode: convStr(res["StudentCode"]),
              project: { projectNo: convStr(res["ProjectNo"]) },
              degree: { nameTh: convStr(res["Degree"]) },
              periodTerm: convStr(res["Period"]).split('/')[0].toString(),
              periodYear: parseInt(convStr(res["Period"]).split('/')[1]),
              curriculum: { curriculumNo: convStr(res["CurriculumNo"]) },
              address: {
                location: convStr(res["Location"]),
                houseNumber: convStr(res["HouseNumber"]),
                moo: convStr(res["Moo"]),
                alley: convStr(res["Alley"]),
                road: convStr(res["Road"]),
                subDistrict: convStr(res["SubDistrict"]),
                district: convStr(res["District"]),
                province: convStr(res["Province"]),
                zipcode: convStr(res["Zipcode"]),
                locationDoc: convStr(res["LocationDoc"]),
                houseNumberDoc: convStr(res["HouseNumberDoc"]),
                mooDoc: convStr(res["MooDoc"]),
                alleyDoc: convStr(res["AlleyDoc"]),
                roadDoc: convStr(res["RoadDoc"]),
                subDistrictDoc: convStr(res["SubDistrictDoc"]),
                districtDoc: convStr(res["DistrictDoc"]),
                provinceDoc: convStr(res["ProvinceDoc"]),
                zipcodeDoc: convStr(res["ZipcodeDoc"]),
              },
              phone: convStr(res["Phone"]),
              mobile: convStr(res["Mobile"]),
              email: convStr(res["Email"])
            }
          });
          vm.$vs.loading()
          const result = await vm.importBorrowersUpdate({
            action: action,
            meta: {...vm.meta, action: action},
            form,
            vm,
            redirect: null
          })
          if(action === "check"){
            vm.check = true
            vm.result = result
            vm.state = 'checked'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }else{
            vm.check = false
            vm.header = []
            vm.tableData = []
            vm.result = result
            vm.state = 'imported'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }
        }
        else if(importType == "SuretiesUpdate"){
          let form = this.tableData.map(res => {
            return {
              prefix: { nameTh: convStr(res["Prefix"]) },
              name: convStr(res["Name"]),
              surname: convStr(res["Surname"]),
              birthDay: convStr(res["BirthDay"]),
              idCardNumber: convStr(res["IdCardNumber"]),
              issueDate: convStr(res["IssueDate"]),
              expDate: convStr(res["ExpDate"]),
              career: convStr(res["Occupation"]),
              position: convStr(res["Position"]),
              affiliate: convStr(res["Affiliate"]),
              address: {
                location: convStr(res["Location"]),
                houseNumber: convStr(res["HouseNumber"]),
                moo: convStr(res["Moo"]),
                alley: convStr(res["Alley"]),
                road: convStr(res["Road"]),
                subDistrict: convStr(res["SubDistrict"]),
                district: convStr(res["District"]),
                province: convStr(res["Province"]),
                zipcode: convStr(res["Zipcode"]),
                locationDoc: convStr(res["LocationDoc"]),
                houseNumberDoc: convStr(res["HouseNumberDoc"]),
                mooDoc: convStr(res["MooDoc"]),
                alleyDoc: convStr(res["AlleyDoc"]),
                roadDoc: convStr(res["RoadDoc"]),
                subDistrictDoc: convStr(res["SubDistrictDoc"]),
                districtDoc: convStr(res["DistrictDoc"]),
                provinceDoc: convStr(res["ProvinceDoc"]),
                zipcodeDoc: convStr(res["ZipcodeDoc"]),
              },
              phone: convStr(res["Phone"]),
              mobile: convStr(res["Mobile"]),
              email: convStr(res["Email"])
            }
          });
          vm.$vs.loading()
          const result = await vm.importSuretiesUpdate({
            action: action,
            meta: {...vm.meta, action: action},
            form,
            vm,
            redirect: null
          })
          if(action === "check"){
            vm.check = true
            vm.result = result
            vm.state = 'checked'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }else{
            vm.check = false
            vm.header = []
            vm.tableData = []
            vm.result = result
            vm.state = 'imported'
            setTimeout(() => {
              vm.$vs.loading.close()
            }, 150)
          }
        }
      } catch (e) {
        // console.log(e)
        vm.$vs.dialog({
          color: 'danger',
          title: vm.$t("general.dialog.title"),
          text: vm.$t("general.dialog.message-error")
        })
      }
    },
  }
}
</script>
